import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { setOperationStatus, userLogin } from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import CheckoutRegister from './Register';
import CheckoutLogin from './Login';
import StepsProgressBar from '../../../../components/StepsProgressBar';
import { formatCartItemsForAnalytics } from '../../../../helpers/commerce';
import { clearPageInformation, setPageInformation, setPageViewSent } from '../../../../store/actions/UI';

import './style.scss';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

const CheckoutLoginOrRegister = () => {
  const PAGE_TITLE = 'Inloggen | VeiligheidNL';
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const history = useHistory();
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], false));
  const nextUrl = '/cart/checkout';
  const location = useLocation();
  const currentPath = location.pathname;

  const totalPrice = useSelector((state) => state.getIn(['commerce', 'cart', 'content', 'attributes', 'order_total', 'subtotal', 'number']));
  const analyticsItems = useSelector((state) => formatCartItemsForAnalytics(state.getIn(['commerce', 'cart', 'products'])));

  const onLogin = (username, password) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_shipping_info',
      ecommerce: {
        currency: 'EUR',
        value: totalPrice,
        items: analyticsItems
      }
    });

    dispatch(userLogin(username, password));
  };

  const goToRegister = () => {
    dispatch(setOperationStatus('user', 'register', null));
    history.push(`/register?destination=${nextUrl}`);
  };

  useEffect(() => {
    if (loggedIn === true) {
      dispatch(setOperationStatus('user', 'register', null));
      history.push(nextUrl);
    }
  }, [dispatch, loggedIn, history]);

  useEffect(() => {
    return () => {
      dispatch(setOperationStatus('user', 'register', null));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearPageInformation());
    dispatch(setPageInformation(PAGE_TITLE));
    dispatch(setPageViewSent(false));
  }, []);

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <StepsProgressBar webShopCurrentPath={currentPath} />
      <Container>
        <div className="CheckoutLoginOrRegister">
          <div className="CheckoutLoginOrRegister__backToPage" onClick={() => history.goBack()}>
            <div className="icon icon-chevron-right" />
            {t('form.login.back_to_cart')}
          </div>

          <div className="row">
            <CheckoutLogin onLogin={onLogin} />
            <div className="divider" />
            <CheckoutRegister goToRegister={goToRegister} />
          </div>
        </div>
      </Container>
    </>
  );
};

export default CheckoutLoginOrRegister;
